'use client';

import { BlockStackingGame } from './BlockStackingGame';

export default function GameSection() {
  return (
    <div className="px-5">
      <BlockStackingGame />
    </div>
  );
}
